import { Module } from 'wrapper6';
import { Modalbox } from '../utils/_modal-box';

export default class VideoModal extends Module {
  ready() {
    new Modalbox('.has-video');
  }
}